import { useTranslation } from "react-i18next";
import { PriceRowProps } from "../../components/types";
import { numberToStringWithComma } from "src/utils/common-util";

// 가격 행 컴포넌트
// 금액 정보를 표시하는 행 컴포넌트
export const PriceRow = ({ label, value, className = "", isTotal = false }: PriceRowProps) => {
  const { t } = useTranslation("common");
  return (
    <div className="base-section-layout-line">
      {/* 라벨 표시 */}
      <p className="base-section-layout-index text-primary3">{label}</p>
      <span className={className}>
        {/* 총계 여부에 따른 스타일 적용 */}
        {isTotal && <span className="base-section-layout-value totalPrice font15">{numberToStringWithComma(value)}</span>}
        {!isTotal && <span className="base-section-layout-value">{numberToStringWithComma(value)}</span>}
        <span className="font15"> {t("currencyUnit")}</span>
      </span>
    </div>
  );
};
